import { render, staticRenderFns } from "./Chefs.vue?vue&type=template&id=bcb7aabc"
import script from "./Chefs.vue?vue&type=script&lang=js"
export * from "./Chefs.vue?vue&type=script&lang=js"
import style0 from "./Chefs.vue?vue&type=style&index=0&id=bcb7aabc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports